<template>
  <div class="user" v-permissions="'invoice:query'">
    开发中！
    <!-- <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <transition name="slide-fade">
      <div class="main" v-show="web == 'main'">
        <div class="title">开票信息</div>
        <el-form ref="form" :inline="true" :model="searchForm" label-width="80px" @submit.native.prevent="false">
          <el-form-item label="公司名称" :label-width="'120px'">
            <el-input
              size="small"
              v-model="searchForm.payer"
              placeholder="请输入公司名称"
              clearable
              @keyup.enter.native="search(1)"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.state" placeholder="请选择状态" size="small" clearable @change="search(1)">
              <el-option v-for="(item, index) in invoiceState" :key="index" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="btn">
            <el-button type="primary" size="small" class="search" @click="search">查询 </el-button>
          </el-form-item>
        </el-form>
        <el-table class="show-pc" :data="tableData" height="72vh" style="width: 100%">
          <el-table-column label="公司名称">
            <template slot-scope="scope">
              <span>{{ scope.row.payer }}</span>
            </template>
          </el-table-column>
          <el-table-column label="公司税号">
            <template slot-scope="scope">
              <span>{{ scope.row.payerTaxNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="地址">
            <template slot-scope="scope">
              <span>{{ scope.row.address }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开票项目">
            <template slot-scope="scope">
              <span>{{ scope.row.serviceProject }}</span>
            </template>
          </el-table-column>
          <el-table-column label="提交时间">
            <template slot-scope="scope">
              <span>{{ scope.row.uploadTime.substring(0, 10) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-for="(item, index) in invoiceState" :key="index" v-show="scope.row.state === item.name">{{
                item.name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-permissions="'invoice:audit'"
                size="mini"
                type="primary"
                plain
                @click="handleEdit(scope.$index, scope.row)"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-table class="show-phone" :data="tableData" height="80vh" style="width: 100%">
          <el-table-column label="开票信息">
            <template slot-scope="scope">
              <div>公司名称：{{ scope.row.payer }}</div>
              <div>开票项目：{{ scope.row.serviceProject }}</div>
              <div>开票时间：{{ scope.row.createTime.substring(0, 10) }}</div>
              <div>
                状态：<span v-for="(item, index) in invoiceState" :key="index" v-show="scope.row.state === item.name">{{
                  item.name
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80px">
            <template slot-scope="scope">
              <el-button
                v-permissions="'user:update'"
                size="mini"
                type="primary"
                plain
                @click="handleEdit(scope.$index, scope.row)"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 500, 1000, 2000]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="edit" v-show="web == 'edit' || web == 'add'">
        <div class="title">{{ web == 'edit' ? '编辑' : '新增' }}</div>
        <div class="el-form" label-position="top">
          <table v-permissions="'invoice:query'" class="detail">
            <tr>
              <td>公司名称: {{ addForm.payer }}</td>
              <td>公司税号: {{ addForm.payerTaxNum }}</td>
            </tr>
            <tr>
              <td>地址: {{ addForm.address }}</td>
              <td>联系电话: {{ addForm.phone }}</td>
            </tr>
            <tr>
              <td>银行: {{ addForm.blank }}</td>
              <td>银行账号: {{ addForm.blankAccount }}</td>
            </tr>
            <tr>
              <td>开票项目: {{ addForm.serviceProject }}</td>
              <td>
                状态:
                <span v-for="(item, index) in invoiceState" :key="index" v-show="addForm.state === item.name">{{
                  item.name
                }}</span>
              </td>
            </tr>
            <tr>
              <td>规格型号: {{ addForm.model }}</td>
              <td>数量: {{ addForm.number }}</td>
            </tr>
            <tr>
              <td>单价: {{ addForm.price }}</td>
              <td>总金额: {{ addForm.total }}</td>
            </tr>
            <tr>
              <td>收件人: {{ addForm.addressee }}</td>
              <td>收件人联系电话: {{ addForm.recipientPhone }}</td>
            </tr>
            <tr>
              <td colspan="2">收件人地址: {{ addForm.recipientAddress }}</td>
            </tr>
            <tr>
              <td colspan="2">备注: {{ addForm.price }}</td>
            </tr>
          </table>

          <div v-permissions="'invoice:audit'">
            <el-form ref="addForm" :model="checkForm" label-width="100px">
              <el-form-item label="审核：">
                <el-radio-group v-model="checkForm.state">
                  <el-radio
                    v-show="item.code !== '1'"
                    v-for="(item, index) in invoiceState"
                    :key="index"
                    :label="item.name"
                  ></el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="退回原因">
                <el-input type="textarea" v-model="checkForm.backReason"></el-input>
              </el-form-item>
              <el-button v-permissions="'invoice:audit'" type="primary" size="small" @click="auditInvoice"
                >保存
              </el-button>
              <el-button type="primary" size="small" plain class="cancel" @click="cancel">返回列表</el-button>
            </el-form>
          </div>
        </div>
      </div>
    </transition> -->
  </div>
</template>

<script>
// import selfTitle from '../components/Title'
export default {
  name: 'User',
  // components: {
  //   selfTitle
  // },
  data() {
    return {
      userInfo: {},
      titles: ['开票信息'],
      web: 'main',
      searchForm: {
        name: '',
        state: ''
      },
      addForm: {
        hiredate: '',
        name: '',
        state: '',
        role: '',
        workNumber: ''
      },
      checkForm: {
        state: '',
        backReason: '' // 退回原因
      },
      invoiceState: [], // 开票信息状态
      menus: [],
      tableData: [],
      currentPage: 1,
      pageSize: 100,
      total: 0
    }
  },
  methods: {
    titleClick(item, index) {
      console.log(item, index)
      if (item === '开票信息') {
        this.web = 'main'
        this.titles = ['开票信息'] // 导航菜单
      }
    },
    search() {
      // 查询
      this.queryInvoice()
    },
    /**
     * 查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
      开票信息状态
      system/code/query?systemId=0&businessId=6
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changs = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.circles = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
            } else if (businessId === 6) {
              this.invoiceState = result.data
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    reset() {
      // 重置
      this.searchForm = {
        name: '',
        state: ''
      }
    },
    add() {
      this.web = 'add'
      this.titles = ['开票信息', '新增']
      setTimeout(() => {
        this.$refs.addForm.clearValidate()
      }, 0)
    }, // 新增
    handleEdit(index, row) {
      // 编辑
      console.log(index, row)
      this.web = 'edit'
      this.titles = ['开票信息', '审核']
      for (const i in row) {
        this.addForm[i] = row[i]
      }
    },
    handleDelete() {
      // 删除
      this.$root.$children[0].vueConfirm(
        { message: '确认要注销此开票信息吗?' },
        () => {
          const param = {
            id: this.addForm.id,
            cid: this.addForm.cid
          }
          this.$get('/user/resign', param).then(
            result => {
              if (result.status === 200) {
                this.search()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消注销')
        }
      )
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.search()
    },
    cancel() {
      this.checkForm = {
        state: '',
        backReason: '' // 退回原因
      }
      this.web = 'main'
      this.titles = ['开票信息']
    },
    // 查询开票信息列表
    queryInvoice() {
      const param = {
        payer: this.searchForm.payer,
        state: this.searchForm.state,
        page: this.currentPage,
        limit: this.pageSize
      }
      this.$post('/invoice/pc/query', param).then(
        result => {
          if (result.status === 200) {
            this.total = result.count
            this.tableData = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询开票信息列表
    auditInvoice() {
      if (!this.checkForm.state) {
        return this.$root.$children[0].vueAlert({ message: '请选择审核状态', type: 'error' })
      }
      const param = {
        id: this.addForm.id,
        state: this.checkForm.state,
        backReason: this.checkForm.backReason
      }
      this.$post('/invoice/pc/audit', param).then(
        result => {
          if (result.status === 200) {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            this.cancel()
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    }
  },
  mounted() {
    // if (this.$common.session.get('userInfo')) {
    //   this.userInfo = this.$common.session.get('userInfo')
    // } else {
    //   return this.$root.$children[0].vueAlert({ message: '未获取到用户信息', type: 'warning' })
    // }
    // this.queryInvoice()
    // this.queryCode(6)
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.user {
  .detail {
    width: 100%;
    tr {
      td {
        padding: 8px;
      }
    }
  }
}
</style>
